import React from 'react';
import * as S from './MainSider/MainSider.styles';
import { RightOutlined } from '@ant-design/icons';
import { useResponsive } from 'hooks/useResponsive';
import { useAppSelector } from '@app/hooks/reduxHooks';
import {
  synergyLogos,
  SynergyLogoVariant,
} from '@app/assets/branding/synergyBrand';

interface SiderLogoProps {
  isSiderCollapsed: boolean;
  toggleSider: () => void;
}
export const SiderLogo: React.FC<SiderLogoProps> = ({
  isSiderCollapsed,
  toggleSider,
}) => {
  const { tabletOnly } = useResponsive();
  const theme = useAppSelector((state) => state.theme.theme);

  const logoVariant: SynergyLogoVariant = isSiderCollapsed
    ? 'standalone'
    : theme === 'light'
    ? 'main'
    : 'reverse';

  return (
    <S.SiderLogoDiv>
      <S.SiderLogoLink to="/">
        <S.BrandLogoSurface>
          <S.BrandLogoViewport $standalone={logoVariant === 'standalone'}>
            <S.BrandLogoImage
              src={synergyLogos[logoVariant]}
              alt="Synergy"
              $variant={logoVariant}
            />
          </S.BrandLogoViewport>
        </S.BrandLogoSurface>
      </S.SiderLogoLink>
      {tabletOnly && (
        <S.CollapseButton
          shape="circle"
          size="small"
          $isCollapsed={isSiderCollapsed}
          icon={<RightOutlined rotate={isSiderCollapsed ? 0 : 180} />}
          onClick={toggleSider}
        />
      )}
    </S.SiderLogoDiv>
  );
};
